// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .danger-border div, [dir] .danger-border-select div input {\n  border-color: red !important;\n}\n.addDialog .vs-dialog {\n  max-width: 1000px;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  max-height: 800px;\n}\n.datatableOrders th:nth-child(1) {\n  display: none;\n}\n.datatableOrders td:nth-child(1) {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
